export default "__VITE_ASSET__B8aik76o__"